import { useNavigate } from "react-router-dom";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import store from "store-js";

export default function GoBackBtn({ color, label, pathname, name }) {
  const navigate = useNavigate();

  // Clear saved user mobile if no QR code is scanned successfully
  const handleGoBack = () => {
    // clearTimeout(timeoutID);
    // store.remove("otpCountDown");
    // sessionStorage.removeItem("OTPref");
    let coupons = store.get("coupons");
    if (coupons && coupons.length < 3) return store.remove("owner_user_id");
  };

  const backToMain = () => {
    // Remove scannedQRcode & coupons from localStorage
    const keys = [
      "coupons",
      "scannedQRcode",
      "owner_customer_id",
      "codeCountDown",
      "timeoutId",
    ];
    keys.forEach((key) => {
      store.remove(key);
    });
    return navigate("/userhome");
  };

  const saveRecord = () => {
    store.remove("voucherUseId");
    store.remove("order");
  };

  return (
    <>
      <button
        type="button"
        className="textBtn left"
        style={{ color: color }}
        onClick={() => {
          if (name === "previewRecord") saveRecord();
          pathname ? navigate(pathname) : backToMain();
          handleGoBack();
        }}
      >
        <FontAwesomeIcon icon={faAngleLeft} className={color} />
        {label || name === "setting" ? label : "返回主頁"}
      </button>
    </>
  );
}
